module.exports = __webpack_public_path__ + "media/images/header24-cf1d5c326c4d8f43460a55d6f6524a9f.png";